"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgReport(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 -4 14 24" }, props),
        React.createElement("path", { d: "M13.944 0a2 2 0 011.373.545l3.056 2.886c.4.378.627.904.627 1.454V15c0 .552-.658 1-1.21 1H6a1 1 0 01-1-1V1a1 1 0 011-1zM13 2H7v12h10V6h-3a1 1 0 01-1-1zm-5 8l8 .001V11.5H8zm0-3h8v1.5H8zm3-3v1.5H8V4z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Report')(SvgReport);
//# sourceMappingURL=Report.js.map